import { Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import DateFieldRange from "./components/DateFieldRange";
import DateFieldDefault from "./components/DateFieldDefault";

interface DateFieldProps {
  /**
   * Render the date field in range mode
   */
  useRange?: boolean;
  /**
   * Render the date field with group by option
   */
  useGroupBy?: boolean;
}

function DateField({ useRange = false, useGroupBy = false }: DateFieldProps) {
  return (
    <div className="request-row d-flex">
      <Col xs={3}>
        <div className="font-weight-bold font-b1 mb-1">
          <FormattedMessage id="tasks.dateHeader" defaultMessage="Date" />
        </div>
        <div className="font-b3 text-secondary">
          <FormattedMessage id="report.selectRequestDate" defaultMessage="Select request date" />
        </div>
      </Col>
      {useRange ? <DateFieldRange /> : <DateFieldDefault useGroupBy={useGroupBy} />}
    </div>
  );
}

DateField.defaultProps = {
  useRange: false,
  useGroupBy: false,
};

export default DateField;
